// src/app/modules/commissionDefault/apis/requestsApi.ts
import axios, { AxiosResponse } from 'axios'
import { getTokenConfig } from '../../../../../src/auth'
import { CommissionDefault } from '../core/CommissionDefault.model'

const BASE = `${process.env.REACT_APP_API_URL}/partners/commission-default`

interface DefaultCommissionResponse {
  data: {
    defaultCommissions: CommissionDefault[]
  }
}

export const configDefaultCommission = async (): Promise<CommissionDefault[]> => {
  const cfg = await getTokenConfig()
  const res: AxiosResponse<DefaultCommissionResponse> = await axios.get(BASE, cfg)
  return res.data.data.defaultCommissions
}

export const updateDefaultCommissionConfig = async (
  commissions: CommissionDefault[]
): Promise<void> => {
  const cfg = await getTokenConfig()
  const res: AxiosResponse = await axios.put(BASE, { defaultCommissions: commissions }, cfg)
  if (res.status !== 200) throw new Error('Error al actualizar comisiones por defecto')
}
